// -----------------------------------------------------------
// FloraIQ — Aba Relatórios de Qualidade
// -----------------------------------------------------------

import { qualityReports, detailedQualityScores } from "@/mocks/quality";

const statusLabels: Record<string, string> = {
  disponivel: "Disponível",
  processando: "Processando",
  pendente: "Pendente",
};

const statusIcons: Record<string, string> = {
  disponivel: "ri-check-line",
  processando: "ri-loader-4-line",
  pendente: "ri-time-line",
};

const statusColors: Record<string, string> = {
  disponivel: "bg-green-100 text-green-700",
  processando: "bg-blue-100 text-blue-700",
  pendente: "bg-yellow-100 text-yellow-700",
};

export default function QualityReportsGrid() {
  return (
    <div className="space-y-6">
      {/* Painel Score de Qualidade */}
      <div>
        <h4 className="text-sm font-semibold text-foreground-800 mb-3">Score de Qualidade por Categoria</h4>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-8 gap-3">
          {detailedQualityScores.map((d) => (
            <div key={d.categoria} className="bg-white rounded-card border border-background-200/70 p-3 text-center">
              <p className="text-xs text-foreground-500 mb-1">{d.categoria}</p>
              <p className={`text-xl font-bold font-heading ${
                d.cor === "success" ? "text-green-600" :
                d.cor === "info" ? "text-blue-600" :
                d.cor === "danger" ? "text-red-600" :
                "text-yellow-600"
              }`}>{d.score}%</p>
              <p className="text-xs text-foreground-400 mt-0.5">{d.aprovados.toLocaleString("pt-BR")}/{d.total.toLocaleString("pt-BR")}</p>
              <div className="mt-2 w-full bg-background-100 rounded-full h-1 overflow-hidden">
                <div
                  className={`h-full rounded-full transition-all duration-700 ${
                    d.score >= 90 ? "bg-green-500" : d.score >= 80 ? "bg-blue-500" : d.score >= 70 ? "bg-yellow-500" : "bg-red-500"
                  }`}
                  style={{ width: `${d.score}%` }}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Grid de relatórios */}
      <div>
        <h4 className="text-sm font-semibold text-foreground-800 mb-3">Relatórios Disponíveis</h4>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {qualityReports.map((rel) => (
            <div key={rel.id} className="bg-white rounded-card border border-background-200/70 p-4 hover:border-background-300/60 transition-all duration-200 flex flex-col">
              <div className="flex items-start gap-3 mb-3">
                <div className="w-9 h-9 rounded-lg bg-blue-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-file-chart-line text-blue-600 text-sm"></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="text-sm font-medium text-foreground-800 mb-1">{rel.title}</h4>
                  <p className="text-xs text-foreground-500 line-clamp-2">{rel.description}</p>
                </div>
              </div>
              <div className="flex items-center justify-between mt-auto pt-3 border-t border-background-100">
                <div className="flex items-center gap-2">
                  <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${statusColors[rel.status]}`}>
                    <i className={`${statusIcons[rel.status]} text-xs ${rel.status === "processando" ? "animate-spin" : ""}`}></i>
                    {statusLabels[rel.status]}
                  </span>
                  {rel.ultimaGeracao !== "-" && (
                    <span className="text-xs text-foreground-400">{rel.ultimaGeracao}</span>
                  )}
                </div>
                <div className="flex items-center gap-1">
                  {rel.status === "disponivel" && (
                    <button className="w-7 h-7 rounded-lg flex items-center justify-center hover:bg-background-100 transition-colors cursor-pointer" title="Visualizar">
                      <i className="ri-eye-line text-foreground-500 text-sm"></i>
                    </button>
                  )}
                  <button className="btn-outline text-xs px-2 py-1 cursor-pointer whitespace-nowrap">
                    {rel.status === "disponivel" ? "Exportar" : "Gerar"}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}